import React, { Component } from "react";
import { Card, message, Tooltip } from "antd";
import { ReactComponent as AudioRec } from "../../../../assets/images/icons/AudioRec.svg";
import { ReactComponent as CopyIcon } from "../../../../assets/images/icons/copy-icon1.svg";
import "./index.scss";

const COLOR_MAP = {
  "Wants order": "#22C55E",
  "Doesn’t want order": "#EF4444",
  Ambiguous: "#F59E0B",
  Fair: "#F59E0B",
  Manipulative: "#EF4444",
  Unclear: "#6B7280",
  Valid: "#3B82F6",
  Incomplete: "#F59E0B",
  "Misled into giving": "#EF4444",
  "Given willingly": "#3B82F6",
  "Not discussed": "#6B7280",
  "Not applicable": "#6B7280",

  High: "#22C55E",
  Moderate: "#F59E0B",
  Low: "#EF4444",
  "Unable to assess": "#6B7280",

  Strong: "#22C55E",
  "Moderate Strength": "#F59E0B",
  Weak: "#EF4444",

  "Strong push to LMD": "#22C55E", // Green
  "Escalate to LMD": "#F59E0B", // Yellow/Orange
  "Reject escalation": "#EF4444", // Red
  "Do not escalate": "#6B7280",
};

class CaseCard extends Component {
  trimText = (text, maxLength) => {
    if (!text) return "";
    const trimmed = text.trim();
    return trimmed.length > maxLength
      ? trimmed.slice(0, maxLength).trim() + "..."
      : trimmed + "...";
  };

  renderColoredText = (label, value) => {
    const color = COLOR_MAP[value] || "#000000";
    return (
      <div className="case-row">
        <span className="case-label">{label}</span>
        <span className="case-value" style={{ color }}>
          {value}
        </span>
      </div>
    );
  };

  copyToClipboard = (text) => {
    if (!text) return;

    try {
      navigator.clipboard.writeText(text);
      // Optional: show some success feedback
      message.success("Copied to clipboard");
    } catch (err) {
      message.error("Failed to copy text: ", err);
    } finally {
      setTimeout(() => {
        message.destroy();
      }, 1000);
    }
  };

  render() {
    const { data } = this.props;

    if (!data) return null; // Or return a fallback UI

    return (
      <Card className="case-card">
        {data.Customer_Intent &&
          this.renderColoredText("Customer Intent:", data.Customer_Intent)}
        {data.Support_Agent_Conduct &&
          this.renderColoredText(
            "Support Agent Conduct:",
            data.Support_Agent_Conduct
          )}
        {data.Transcript_Validity &&
          this.renderColoredText(
            "Transcript Validity:",
            data.Transcript_Validity
          )}
        {data.OTP_Issue && this.renderColoredText("OTP:", data.OTP_Issue)}
        {data.Intent_Level &&
          this.renderColoredText("Intent Level:", data.Intent_Level)}
        {data.Score && this.renderColoredText("Score:", data.Score)}
        {data.Case_Strength &&
          this.renderColoredText("Case Strength:", data.Case_Strength)}
        {data.Final_Action &&
          this.renderColoredText("Final Action:", data.Final_Action)}

        {data.Call_Summary && (
          <div className="call-box">
            <AudioRec />
            <Tooltip title={data.Call_Summary}>
              <div className="call-summary-text">
                {this.trimText(data.Call_Summary, 60)}
              </div>
            </Tooltip>
            <span onClick={() => this.copyToClipboard(data.Call_Summary)}>
              <CopyIcon />
            </span>
          </div>
        )}

        {data.Case_Summary && (
          <div className="call-box">
            <AudioRec />
            <Tooltip title={data.Case_Summary}>
              <div className="case-summary-text">
                {this.trimText(data.Case_Summary, 60)}
              </div>
            </Tooltip>
            <Tooltip title="Copy Conversation">
              <span onClick={() => this.copyToClipboard(data.Case_Summary)}>
                <CopyIcon />
              </span>
            </Tooltip>
          </div>
        )}
      </Card>
    );
  }
}

export default CaseCard;
